export default __webpack_public_path__ + "static/media/headerImg1.2faffd14.png";